module.exports = __webpack_public_path__ + "static/media/02.6717b2b1.png";